module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [(_vm.isModalActive) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeModalActive
    }
  }), _c('div', {
    staticClass: "box position-relative has-text-left margin-right-10 margin-left-10"
  }, [_c('div', [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.item.descripcionAlgoritmo)) + ": " + _vm._s(_vm.item.nombreEmpleado))])]), (_vm.item.classes === 'solicitud-permisos' || _vm.item.classes === 'permisos') ? _c('div', [_c('span', {
    staticClass: "text-small"
  }, [_vm._v("Tipo: ")]), _c('span', [_vm._v(_vm._s(_vm.item.descripcionTipo))])]) : _vm._e(), _c('div', [_c('span', {
    staticClass: "text-small"
  }, [_vm._v("Fecha" + _vm._s(_vm.item.desde === _vm.item.hasta ? '' : 's') + ": ")]), _c('span', [_vm._v(_vm._s(_vm.item.desde) + " ")]), (_vm.item.desde !== _vm.item.hasta) ? _c('span', [_vm._v("- " + _vm._s(_vm.item.hasta))]) : _vm._e()]), (_vm.item.horaDesde) ? _c('div', [_c('span', {
    staticClass: "text-small"
  }, [_vm._v("Horas: ")]), _c('span', [_vm._v(_vm._s(_vm.item.horaDesde) + " - " + _vm._s(_vm.item.horaHasta))])]) : _vm._e(), (_vm.item.classes.includes('solicitud')) ? _c('div', [_c('span', {
    staticClass: "text-small"
  }, [_vm._v("Estado: ")]), _c('span', [_vm._v(_vm._s(_vm.item.descripcionEstado))])]) : _vm._e(), (_vm.item.classes.includes('solicitud') || _vm.item.classes === 'vacaciones') ? _c('div', [_c('span', {
    staticClass: "text-small"
  }, [_vm._v("Creación solicitud: ")]), _c('span', [_vm._v(_vm._s(_vm.item.fechaCreacionSolicitud))])]) : _vm._e()])]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-overlay"
  }, [_c('loading')], 1) : _vm._e(), _c('div', {
    staticClass: "flex mb-5"
  }, [_c('div', {
    staticClass: "flex flex-1 filtros-check"
  }, [(_vm.perfilVacaciones === 'recursos humanos') ? _c('div', {
    staticClass: "control flex"
  }, [_c('input', {
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.verTodos
    },
    on: {
      "change": _vm.verTodosChanged
    }
  }), _c('span', {
    staticClass: "ml-5 asc"
  }, [_vm._v("Ver todos los empleados")])]) : _vm._e(), _c('div', {
    staticClass: "control flex ml-15"
  }, [_c('input', {
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.meIncluyo
    },
    on: {
      "change": _vm.meIncluyoChanged
    }
  }), _c('span', {
    staticClass: "ml-5 asc"
  }, [_vm._v("Incluir mi información")])]), _c('div', {
    staticClass: "control flex ml-15"
  }, [_c('input', {
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.verSolicitudesAprobadas
    },
    on: {
      "change": _vm.verSolicitudesAprobadasChanged
    }
  }), _c('span', {
    staticClass: "ml-5 asc"
  }, [_vm._v("Ver solo aprobadas")])])]), _vm._m(0)]), _c('calendar-view', {
    staticClass: "theme-default holiday-us-traditional holiday-us-official",
    attrs: {
      "show-date": _vm.showDate,
      "items": _vm.lista,
      "startingDayOfWeek": 1,
      "periodChangedCallback": _vm.fetch
    },
    on: {
      "click-item": _vm.onItemClick
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(t) {
        return _c('calendar-view-header', {
          attrs: {
            "header-props": t.headerProps
          },
          on: {
            "input": _vm.setShowDate
          }
        })
      }
    }])
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-1 aic mb-5 leyenda"
  }, [_c('div', {
    staticClass: "seen-vacaciones"
  }, [_c('span', [_vm._v("Vacaciones")])]), _c('div', {
    staticClass: "seen-solicitud-vacaciones"
  }, [_c('span', [_vm._v("Solicitud de Vacaciones")])]), _c('div', {
    staticClass: "seen-permisos"
  }, [_c('span', [_vm._v("Permisos")])]), _c('div', {
    staticClass: "seen-solicitud-permisos"
  }, [_c('span', [_vm._v("Solicitud de Permisos")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0944ace","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Reporte_Calendario.vue
// module id = 864
// module chunks = 0